export default {
  scheduled_order: 'Commande planifiée',
  show_more: 'Afficher plus',
  show_less: 'Afficher moins',
  schedule_order: 'Planifier la commande',
};
